const proposalKeys = {
  equivalent: "equivalent",
  analog: "analog",
  form: "form",
};

export default proposalKeys;
